import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { getCookie } from "../components/Cookie.jsx";
import DataTable from "react-data-table-component";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import "../index.css";

const deslugifyKey = (key) => {
  return key
    .replace(/[_-]/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const isNumber = (value) =>
  typeof value === "number" && !isNaN(value);

const generateColumnsFromData = (documents) => {
  if (!documents || documents.length === 0) return [];

  const sampleRow = documents[0];

  return Object.keys(sampleRow).map((key, index) => {
    const isNumericColumn = isNumber(sampleRow[key]);

    return {
      id: index + 1,
      name: deslugifyKey(key),
      selector: (row) => row?.[key] ?? (isNumericColumn ? 0 : "-"),
      sortable: true,
      // right: isNumericColumn,
      center: true,
      // maxWidth: "300px",
      flex: 1,
      cell: (row) => {
        let cellValue = row?.[key] ?? (isNumericColumn ? 0 : "-");
        
        if (typeof cellValue === "boolean") {
          cellValue = String(cellValue);
        }
        
        if (typeof cellValue === "object" || Array.isArray(cellValue)) {
          cellValue = "-";
        }

        const handleCopy = async () => {
          try {
            await navigator.clipboard.writeText(cellValue);
            toast.success("Copied to clipboard!");
          } catch (err) {
            console.error("Failed to copy:", err);
          }
        };
        
        return (
          <Tooltip 
            title={
              <div>
                {cellValue}
              </div>
            } 
            arrow
          >
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "200px",
                cursor: "pointer",
                userSelect: "text",
              }}
            >
              {cellValue}
            </div>
          </Tooltip>
        );
      },
    };
  });
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#f1f4f9",
    },
  },
};
//************************************** */



//***************************************** */

const Carousel = ({
  data,
  selectedImageUrl,
  selectedImageData,
  onSlideChange,
  currentSlideIndex,
}) => {
  const [currentImageData, setCurrentImageData] = useState([]);
  const [storedData, setStoredData] = useState([]);
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [isBusDropdownOpen, setBusDropdownOpen] = useState(false);
  const [isFlightDropdownOpen, setFlightDropdownOpen] = useState(false);
  const [isHotelRoomDropdownOpen, setHotelRoomDropdownOpen] = useState(false);
  const [isHotelCatDropdownOpen, setHotelCatDropdownOpen] = useState(false);
  const [isRedbusCatDropdownOpen, setRedbusCatDropdownOpen] = useState(false);
  const [isRedbusSeatDropdownOpen, setRedbusSeatDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [dataType, setDataType] = useState(""); // Default data type
  const [isOpen, setIsOpen] = useState(false);
  const sliderRef = useRef(null);
  const token = getCookie("sqa_token");
  

  const [customizableCols, setCustomizableCols ] = useState([])
  const [isCustomDropdownOpen, setIsCustomDropdownOpen] = useState(false);
  const [customColumnVisibility, setCustomColumnVisibility] = useState({})
  const visibilityChangedRef = useRef(false);

  const navigate = useNavigate();


  const imageData = Array.isArray(data)
    ? data.filter((doc) => doc.screenshot_url !== null && doc.file_name)
    : [];

  const images = Array.isArray(imageData)
    ? imageData.map((doc) => doc.screenshot_url)
    : [];


  const fetchPreferences = async() => {
    try {
      const response = await fetch("/sqa/api/get_user_preferences/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          batch_id: dataType?.batch_id,
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          navigate("/auth/user-info");
        }
      }

      const result = await response.json()

      if (result?.preferences?.customVisibility) {
        setCustomColumnVisibility((prev) => {
          const updated = { ...prev };

          Object.keys(result.preferences.customVisibility).forEach((key) => {
            if (
              key in prev &&
              result.preferences.customVisibility[key] === false
            ) {
              updated[key] = false;
            }
          });

          return updated;
        });
      }
      

    } catch (err) {
      console.error("Failed to save custom visibility", err);
    }
  }

  const saveCustomVisibility = async (visibility) => {
    try {
      await fetch("/sqa/api/user_preferences/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          batch_id: dataType?.batch_id,
          preferences: {
            customVisibility: visibility,
          },
        }),
      });
    } catch (err) {
      console.error("Failed to save custom visibility", err);
    }
  };


  useEffect(()=>{
    if (dataType?.batch_id && customizableCols.length > 0) {
      fetchPreferences();
    }
  // }, data, storedData, dataType)
  // }, [data])
  }, [data, storedData])


  // Set the default selectedImageData based on the currentSlideIndex on mount
  useEffect(() => {
    if (imageData && imageData.length > 0) {
      setCurrentImageData(imageData[currentSlideIndex] || imageData[0]);
      setDataType(imageData[currentSlideIndex] || imageData[0]);
    }
  }, [imageData, currentSlideIndex]);


  useEffect(() => {

    // dropdown just CLOSED
    if (!isCustomDropdownOpen && visibilityChangedRef.current) {
      saveCustomVisibility(customColumnVisibility);
      visibilityChangedRef.current = false; // reset flag
    }
  }, [isCustomDropdownOpen]);

  // Fetch API with selectedImageData on mount
  useEffect(() => {
    const fetchData = async () => {
      if (currentImageData && currentImageData.length != 0) {
        try {
          const response = await fetch("/sqa/api/ss_image_data/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Include token if required
            },
            body: JSON.stringify({
              nextImageData: currentImageData, // Sending selectedImageData as payload
            }),
          });

          if (!response.ok) {
            if (response.status === 401) {
                navigate("/auth/user-info");
              }
            throw new Error("Network response was not ok");
          }

          const responseData = await response.json();

          if (responseData.documents && responseData.documents.length > 0) {
            setStoredData(responseData.documents);
            
            const generatedCols = generateColumnsFromData(responseData.documents)

            setCustomizableCols(generatedCols)
            
            const customVis = generatedCols.reduce((obj, key)=>{
              obj[key.name] = true
              return obj
            }, {})
                        
            setCustomColumnVisibility(customVis)

          } else {
            setStoredData([]);
          }
        } catch (error) {
          console.error("Error making API call:", error);
          setStoredData([]);
        }
      }
    };

    fetchData();
  }, [currentImageData]); // Only run when selectedImageData changes

  // Update the selected slide when selectedImageUrl changes
  useEffect(() => {
    if (selectedImageUrl && sliderRef.current) {
      const index = images.indexOf(selectedImageUrl);
      if (index !== -1) {
        sliderRef.current.slickGoTo(index);
        setCurrentImageData(imageData[index]);
      }
    }
  }, [selectedImageUrl, images, imageData]);

  const renderHeader = (name) => (
    <div className="whitespace-normal break-words text-center font-bold text-sm ">
      {name}
    </div>
  );

  const filteredData = (() => {

    let dataToFilter = storedData;

    return (
      dataToFilter &&
      dataToFilter.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString()?.toLowerCase()?.includes(searchQuery.toLowerCase())
        )
      )
    );
  })();


  const toggleDropdown = (type) => {
    setIsOpen(!isOpen);
    setIsCustomDropdownOpen(!isCustomDropdownOpen)
  };

  const toggleCustom = (columnName) => {
    setCustomColumnVisibility((prev)=>{
      const updated = {
        ...prev,
        [columnName]: !prev[columnName],
      };

      visibilityChangedRef.current = true; // mark dirty
      return updated;
    })
  }

  // Custom
  const visibleCustomColumn = customizableCols?.filter(
    (column) => customColumnVisibility[column.name]
  )

  const settings = {
    // dots: images.length > 1,
    lazyLoad: true,
    infinite: images.length > 1,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    // nextArrow: <ArrowRightIcon />,
    // prevArrow: <ArrowLeftIcon />,
    ref: sliderRef,
    beforeChange: async (current, next) => {
      const nextImageData = imageData[next];
      setCurrentImageData(nextImageData);

      // Check if the values exist before making the API call
      // try {
      //   const response = await fetch("/sqa/api/ss_image_data/", {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`, // Include token if required
      //     },
      //     body: JSON.stringify({
      //       nextImageData,
      //     }),
      //   });

      //   if (!response.ok) {
      //     throw new Error("Network response was not ok");
      //   }

      //   const responseData = await response.json();

      //   if (responseData.documents && responseData.documents.length > 0) {
      //     setStoredData(responseData.documents);
      //   } else {
      //     setStoredData([]);
      //   }
      // } catch (error) {
      //   console.error("Error making API call:", error);
      //   setStoredData([]);
      // }

      if (onSlideChange) {
        onSlideChange(next);
      }
    },
  };

  return (
    <>
      <Slider {...settings} ref={sliderRef} className="custom-height-carousel">
        {images.length > 0 ? (
          images.map((url, index) => (
            <div key={index} className="text-center">
              <h3 className="text-lg font-bold mb-2">
                SS for Image{" "}
                <span className="text-sm font-normal">
                  (click to download image)
                </span>
              </h3>
              <img
                src={url}
                alt="No image"
                className="w-full h-[10rem] object-cover rounded-xl cursor-pointer"
                loading="lazy" // Add lazy loading
                onClick={() => window.open(url, "_blank")}
              />
              <div>
                <div className="w-full text-left">
                  <>
                    {/* Custom Table */}
                    {
                      dataType?.batch_id 
                    && (
                      <>
                        {storedData?.length != 0 && (
                          <div className="flex items-center justify-between py-10">
                            <div className="relative inline-block text-left">
                              {/* Aligns button to left */}
                              <button
                                onClick={() => toggleDropdown()}
                                className="bg-gray-200 px-4 py-2 border border-gray-300 rounded-md w-full text-left flex justify-between items-center"
                              >
                                Select Columns
                                {isOpen ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </button>
                              {isCustomDropdownOpen && (
                                <div className="absolute z-10 bg-white border border-gray-300 rounded-md shadow-lg p-2 mt-1 w-48 max-h-48 overflow-y-auto">
                                  <button 
                                    type="button"
                                    className="btn btn-primary btn-sm w-100 mb-1"
                                    onClick={()=>{
                                      setCustomColumnVisibility((prev)=>{
                                        const updated = {};
                                          Object.keys(prev).forEach(key => {
                                            updated[key] = true;
                                          });
                                          return updated;
                                      })

                                      visibilityChangedRef.current = true
                                    }}
                                    >
                                    Select All
                                  </button>

                                  <button 
                                    type="button"
                                    className="btn flex items-center py-1"
                                    onClick={()=>{
                                      setCustomColumnVisibility((prev)=>{
                                        const updated = {};
                                          Object.keys(prev).forEach((key, index) => {

                                            updated[key] = false;

                                            if (key === "Id") updated[key] = true
                                            
                                            else if (index === 0) updated[key] = true
                                            
                                          });
                                          return updated;
                                      })

                                      visibilityChangedRef.current = true
                                    }}
                                  >
                                    Clear
                                  </button>
                                  
                                  {customizableCols.map((column) => (
                                    <label
                                      key={column?.id}
                                      className="flex items-center py-1"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          customColumnVisibility[
                                            column?.name
                                          ]
                                        }
                                        onChange={() =>
                                          toggleCustom(column?.name)
                                        }
                                        className="mr-2"
                                      />
                                      {column?.name}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </div>

                            <div className="w-1/3">
                              <input
                                type="text"
                                placeholder="Search here..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="border rounded-md px-4 py-2 w-full"
                              />
                            </div>
                          </div>
                        )}
                        
                        <DataTable
                          columns={visibleCustomColumn.map((column) => ({
                            ...column,
                            name: renderHeader(column.name),
                          }))}
                          data={filteredData}
                          customStyles={customStyles}
                          noDataComponent={
                            <div className="py-10">No Data Found</div>
                          }
                          pagination
                        />
                      </>
                    )}
                  </>
                </div>
              </div>{" "}
              {/* Closing the div for the toggle and DataTable section */}
            </div> // Closing the div for each image item
          ))
        ) : (
          <div className="text-center">
            <p>No images available</p>
          </div>
        )}
      </Slider>
    </>
  );
};

export default Carousel;
